import { defineStore } from 'pinia';
import { ref, Ref } from 'vue';

export const useStateStore = defineStore('state', () => {
	const navWarningActive: Ref<boolean> = ref(false);

	return { navWarningActive };
});
